module.exports = __webpack_public_path__ + "static/media/mobile-mockup.b125dadf.png";